export default function InfoPage() {
  const terms = [
    {
      term: "Δv (Delta-V)",
      definition:
        "A measure of how much change in velocity is required to alter an object's trajectory. In asteroid deflection, higher Δv means a stronger push or pull needed to move it off-course."
    },
    {
      term: "MOID (Minimum Orbit Intersection Distance)",
      definition:
        "The smallest possible distance between Earth's orbit and an asteroid’s orbit. A smaller MOID indicates a higher potential for collision."
    },
    {
      term: "Palermo Scale",
      definition:
        "A logarithmic scale used to compare the likelihood of a potential impact with the background risk of impacts from random objects. Positive values indicate unusually high risks."
    },
    {
      term: "Eccentricity",
      definition:
        "Describes how stretched an orbit is. A value of 0 is a perfect circle, while values approaching 1 indicate a highly elongated orbit."
    },
    {
      term: "Inclination",
      definition:
        "The tilt of an orbit relative to Earth's orbital plane. Higher inclination means the orbit is more tilted compared to Earth's orbit."
    },
    {
      term: "Semi-Major Axis",
      definition:
        "Half the longest axis of an elliptical orbit. It defines the overall size of the orbit and its average distance from the Sun."
    },
    {
      term: "Impact Energy (MT TNT)",
      definition:
        "The total energy released during impact, measured in megatons of TNT. It’s a measure of destructive potential, combining mass and velocity."
    },
    {
      term: "Energy Lost in Atmosphere (MT TNT)",
      definition:
        "The amount of kinetic energy dissipated as heat and shock while the asteroid travels through the atmosphere before hitting the ground."
    },
    {
      term: "Impact Velocity (km/s)",
      definition:
        "The final speed of the asteroid or its fragments when they reach Earth's surface after atmospheric deceleration."
    },
    {
      term: "Breakup Altitude (km)",
      definition:
        "The height above the ground where the asteroid begins to fragment due to aerodynamic stress exceeding its structural strength."
    },
    {
      term: "Casualties/Deaths",
      definition:
        "Estimated human fatalities or severe injuries resulting from blast waves, thermal radiation, or secondary effects of the impact."
    },
    {
      term: "Final Crater Diameter (m/km)",
      definition:
        "The diameter of the final crater after the collapse of the transient cavity and debris settling."
    },
    {
      term: "Crater Depth (m)",
      definition:
        "The vertical distance from the crater rim to the floor, indicating the energy and scale of the impact."
    },
    {
      term: "Breccia Thickness (m)",
      definition:
        "The depth of fragmented rock and debris that fills the crater floor after impact."
    },
    {
      term: "Fireball Radius (km)",
      definition:
        "The distance from the impact point within which intense heat causes severe burns and ignition of materials."
    },
    {
      term: "Duration of Irradiation (min)",
      definition:
        "The length of time the area near the impact is exposed to dangerous levels of thermal radiation."
    },
    {
      term: "Peak Pressure (psi)",
      definition:
        "The highest pressure in the shockwave produced by the explosion. 5 psi is enough to destroy most residential structures."
    },
    {
      term: "Max Wind Velocity (m/s)",
      definition:
        "The top wind speeds generated by the air blast. Extremely high winds can uproot trees and demolish buildings."
    },
    {
      term: "Sound Intensity (dB)",
      definition:
        "The loudness of the impact’s air blast. Sounds above 130 dB cause immediate hearing damage."
    },
    {
      term: "Tsunami Arrival Time (min)",
      definition:
        "The time it takes for tsunami waves generated by a water impact to reach nearby coastlines."
    },
    {
      term: "Tsunami Wave Height (m)",
      definition:
        "The maximum height of tsunami waves created by an ocean impact event."
    },
    {
      term: "Seismic Effects - Arrival Time (s)",
      definition:
        "The time it takes for seismic waves from the impact to reach a given location."
    },
    {
      term: "Seismic Effects - Thickness (cm)",
      definition:
        "The thickness of debris and ejecta deposited by the impact’s seismic activity."
    },
    {
      term: "Richter Scale",
      definition:
        "A logarithmic measure of earthquake magnitude. Each whole number represents a tenfold increase in amplitude."
    },
    {
      term: "Population Affected",
      definition:
        "The number of people living within the area directly affected by the impact and secondary effects like fire and shockwaves."
    },
    {
      term: "Disaster Score",
      definition:
        "A composite severity score from 0–100 that considers both impact energy and affected population to represent total devastation potential."
    },
    {
      term: "Gravity Tractor",
      definition:
        "A spacecraft that hovers near an asteroid and uses its own gravity to slowly alter the asteroid’s trajectory."
    },
    {
      term: "Kinetic Impactor",
      definition:
        "A spacecraft designed to collide directly with an asteroid at high speed, transferring momentum to change its orbit."
    },
    {
      term: "Laser Ablation",
      definition:
        "A technique that vaporizes asteroid surface material using lasers, producing a small thrust that gradually shifts its trajectory."
    },
    {
      term: "Tectonic Fault Lines",
      definition:
        "Cracks in Earth’s crust where earthquakes occur. These can amplify seismic effects if an impact happens nearby."
    },
    {
      term: "Population Density Layer",
      definition:
        "A map overlay that visualizes how many people live per unit area, highlighting high-risk zones for impact."
    },
    {
      term: "Atmospheric Entry",
      definition:
        "The process of the asteroid entering Earth’s atmosphere, losing speed and energy due to frictional heating and air resistance."
    },
    {
      term: "Energy Yield (Joules / Megatons)",
      definition:
        "The total energy release from impact or explosion, expressed in either joules or TNT equivalent."
    }, {
    term: "Laser Ablation",
    definition:
      "A planetary defense technique that uses high-powered lasers to vaporize material from an asteroid’s surface. The escaping vapor (plume) creates thrust, gradually altering the asteroid’s trajectory."
  },
  {
    term: "Ablation Thrust",
    definition:
      "The small reactive force produced when material is vaporized and ejected from an asteroid's surface. It pushes the asteroid in the opposite direction, changing its orbit over time."
  },
  {
    term: "Laser Power (MW)",
    definition:
      "The output power of the laser system measured in megawatts (MW). Higher power increases the rate of surface vaporization and therefore the overall deflection effect."
  },
  {
    term: "Efficiency (η)",
    definition:
      "A dimensionless factor (typically between 0.2–0.6) representing how effectively absorbed laser energy is converted into kinetic energy of the escaping vapor. Higher efficiency yields greater thrust for the same power."
  },
  {
    term: "Ablation Rate",
    definition:
      "The amount of material vaporized per second from the asteroid’s surface, directly influenced by laser power, absorption, and efficiency."
  },
  {
    term: "Plume",
    definition:
      "The stream of gas and particles ejected from the asteroid during laser ablation. Its direction and speed determine the net thrust imparted to the asteroid."
  },
  {
    term: "Duration (days)",
    definition:
      "The total period during which the laser system is active. A longer firing duration allows more cumulative thrust and a greater change in the asteroid’s orbit."
  },
  {
    term: "Direction",
    definition:
      "The orientation of the ablation jet relative to the asteroid’s orbital motion. Along Velocity pushes it forward or backward along its orbit, Radial points toward or away from the Sun, and Normal acts perpendicular to the orbital plane."
  },
  {
    term: "Energy Absorption",
    definition:
      "The fraction of laser energy absorbed by the asteroid surface. Surfaces with low reflectivity (dark materials) absorb more energy, making ablation more efficient."
  },
  {
    term: "Thermal Conduction Loss",
    definition:
      "Heat loss through the asteroid’s material that does not contribute to vaporization. Lower conduction increases the efficiency of laser ablation."
  },
  {
    term: "Spot Size",
    definition:
      "The diameter of the laser beam where it hits the asteroid. Smaller spot sizes concentrate energy, raising local temperatures and increasing the ablation rate."
  }
  ];

  return (
    <div className="max-w-3xl mx-auto px-6 py-12 text-gray-200">
      <h1 className="text-3xl font-bold mb-6 text-center">Asteroid Impact Glossary</h1>
      <p className="text-gray-400 mb-10 text-center">
        A complete reference guide for all physical, orbital, and hazard-related terms used throughout the simulation.
      </p>

      <div className="space-y-6">
        {terms.map(({ term, definition }) => (
          <div
            key={term}
            className="border mt-5 border-gray-700 rounded-xl p-4 bg-gray-800/70 hover:bg-gray-800 transition"
          >
            <h3 className="font-semibold text-lg text-white mb-1">{term}</h3>
            <p className="text-sm text-gray-300 leading-relaxed">{definition}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
